export default __webpack_public_path__ + "static/media/timeline-07.b471263c.png";